<button
    #trigger="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="actions__btn"
    [class.actions__btn--active]="showActionsMenu"
    [class.actions__btn--has-content]="hasNgContent"
    (click)="menuClick($event)"
>
    @if (!hasNgContent) {
    <svg class="actions__btn-icon" [class.actions__btn-icon--active]="showActionsMenu">
        <use xlink:href="../../../assets/img/sprite.svg#icon-dots"></use>
    </svg>
    }
    <span #contentWrapper>
        <ng-content></ng-content>
    </span>
</button>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="showActionsMenu"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    [cdkConnectedOverlayHasBackdrop]="false"
    (overlayOutsideClick)="closeMenu()"
    (detach)="closeMenu()"
>
    <ul @fadeInOut class="actions__menu actions__menu--{{ position }}" [ngStyle]="panelStyle">
        @for (option of options; track option.id) {
        <li
            class="actions__option actions__option--{{ option?.data?.type }}"
            data-cy="actions__option-{{ option.id }}"
            (click)="onActionClick(option.id, $event)"
            [class.actions__option--disabled]="option.disabled"
            [tp]="option.tooltip ?? ''"
        >
            @if (option.icon) {
            <svg class="actions__btn-action-icon" [ngStyle]="{ fill: option.iconColor }">
                <use [attr.xlink:href]="'../../../assets/img/sprite.svg#icon-' + option.icon"></use>
            </svg>
            }

            {{ option.value }}
        </li>
        }
    </ul>
</ng-template>
